import api from "../axiosInstance";

export const uploadFiles = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    // example response
    // {
    //     "status": "success",
    //     "photos": [
    //       "file_1738862230226_AdobeStock_550794135_Preview.jpeg"
    //     ]
    //   }

    const response = await api.post(`/s3`, formData, {
      headers: {
        "Content-type": "multipart/form-data",
        Accept: "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading image:", error);
    return null;
  }
};
